import axiosInstance from "../instance";

// Get All Categories
const fetchBanners = async () => {
    const response = await axiosInstance.get('/banners');
    return response.data;
}

const addBanners = async (formData) => {
    const payload = new FormData();

    if (formData instanceof FormData) {
        for (const [key, value] of formData.entries()) {
            if (value instanceof File) {
                payload.append('images[]', value);
            } else if (Array.isArray(value)) {
                value.forEach((file) => payload.append('images[]', file));
            } else {
                payload.append(key, value);
            }
        }
    } else {
        payload.append('images[]', formData);
    }

    const response = await axiosInstance.post('/banners', payload);
    return response.data;
}

const deleteBanner = async (bannerId, image) => {
    const response = await axiosInstance.delete(`/banners/${bannerId}`);
    return response.data;
}

export { fetchBanners, addBanners, deleteBanner };
